var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.handleScroll),expression:"handleScroll"}],staticClass:"back-to-top goTop",on:{"click":_vm.backToTop}},[_c('img',{attrs:{"src":"/img/up-arrow.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }